module.exports = __webpack_public_path__ + "img/topic_1.9bab7445.png";